import { CANVAS_DELETE_OWNER_ATTRIBUTE } from '../constants';

const EDITABLE_SURFACE_SELECTOR = '[contenteditable]:not([contenteditable="false"])';
const CANVAS_DELETE_OWNER_SELECTOR = `[${CANVAS_DELETE_OWNER_ATTRIBUTE}]`;

const isDeleteBlockingElement = (node: EventTarget | null): boolean => {
  if (!(node instanceof HTMLElement)) {
    return false;
  }

  if (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement || node instanceof HTMLSelectElement) {
    return true;
  }

  return node.closest(EDITABLE_SURFACE_SELECTOR) !== null || node.closest(CANVAS_DELETE_OWNER_SELECTOR) !== null;
};

const connectedActiveElement = (): EventTarget | null => {
  const active = document.activeElement;

  // Unmounting a focused catalog search field or transform Back button can leave
  // `activeElement` pointing at a detached input. That keydown targets body —
  // composedPath is the snapshot; a disconnected node must not block canvas delete.
  if (!(active instanceof HTMLElement) || !active.isConnected) {
    return null;
  }

  return active;
};

/**
 * Backspace on a composer chip unmounts the chip before any delayed delete runs, so
 * `document.activeElement` is often `body` by then. The key event's composed path is a
 * snapshot from dispatch and still includes the editor / chat sidebar.
 */
export const shouldIgnoreCanvasDeleteShortcut = (event: KeyboardEvent): boolean => {
  if (typeof event.composedPath === 'function' && event.composedPath().some(isDeleteBlockingElement)) {
    return true;
  }

  return isDeleteBlockingElement(connectedActiveElement());
};
